var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.item.year))]),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.item.filetype))]),_c('td',{staticClass:"text-right"},[_c('IconBtn',{attrs:{"title":"PDF","icon":"mdi-download","small":false,"x-small":true,"loading":_vm.loading},on:{"click":function($event){return _vm.download(_vm.item)}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }